import Rails from "@rails/ujs"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []

  submit_form(event) {
    event.preventDefault()
    Rails.fire(event.target.closest('form'), 'submit')
  }

}
